import request from '@/utils/request'

// 获取渠道总计报表列表
export function getList(params = {}) {
  return request({
    url: '/report_form/predit/channel_form_total',
    method: 'get',
    params
  })
}

export function exportChannelGeneralReport(data = {}) {
  return request({
    url: '/report_form/export/channel_form_total',
    method: 'post',
    data
  })
}
